import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsKeyboardArrowUp = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="m12 10.8-4.6 4.6L6 14l6-6 6 6-1.4 1.4z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsKeyboardArrowUp);
const Memo = memo(ForwardRef);
export default Memo;
